var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-new rounded-circle d-flex flex-column align-items-center justify-content-center"},[_c('div',[_vm._v("NEW")])])}]

export { render, staticRenderFns }